import { Organization } from '../../domain/organization/Organization';
import { OrganizationUser } from '../../domain/organization/OrganizationUser';
import { OrganizationResources } from '../../domain/resources/OrganizationResources';
import { OrganizationActionType, OrganizationActions } from './actions';

export interface OrganizationState {
  organization?: Organization;
  resources?: OrganizationResources;
  users?: OrganizationUser[];
}

export const getInitialState = (): OrganizationState => ({
  organization: undefined,
  resources: undefined,
  users: undefined,
});

export const OrganizationReducer = (state: OrganizationState, action: OrganizationActions): OrganizationState => {
  switch (action.type) {
    case OrganizationActionType.FETCH_ORGANIZATION_SUCCESS:
    case OrganizationActionType.UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        organization: action.payload.organization,
      };
    case OrganizationActionType.FETCH_RESOURCES_SUCCESS:
      return {
        ...state,
        resources: action.payload.resources,
      };
    case OrganizationActionType.FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.users,
      };
    case OrganizationActionType.RESET_ORGANIZATION:
      return getInitialState();
    default:
      return state;
  }
};
